import LastResult from "../components/utils/LastResult";
import Navigation from "../components/utils/Navigation";
import { fromNow, diffDate, prettyBytes, waitSeconds } from '../utils/utilitiesmodule';
import PCLink from "../components/utils/PCLink.vue"
import BackupView from '../components/dialogs/view/BackupView';
import PCLicenseLink from '../components/utils/PCLicenseLink.vue';
import PCBackupLink from '../components/utils/PCBackupLink.vue';
import StatsCollector from '../components/stats/StatsCollector.vue'
import NoDataAvailable from "../components/utils/NoDataAvailable.vue";
import VueApexCharts from 'vue-apexcharts'
import { EVENTS_MESSAGES, PC_MESSAGES } from '../utils/messages';
import NestedDoughnutChart from "../components/stats/NestedDoughnutChart.vue";
import AreaChart from '../components/stats/AreaChart.vue';
import HorizontalBarChart from '../components/stats/HorizontalBarChart.vue';
import StatsRemote from '../components/stats/StatsRemote.vue';
import IperiusONEIcon from "../components/utils/IperiusONEIcon.vue";

//import api from "../router/api";

export default {
    name: "Dashboard",
    components: {
        "LastResult": LastResult,
        "PCLink": PCLink,
        "PCLicenseLink": PCLicenseLink,
        "PCBackupLink": PCBackupLink,
        StatsCollector,
        NoDataAvailable,
        Navigation,
        BackupView,
        apexchart: VueApexCharts,
        "NestedDoughnutChart": NestedDoughnutChart,
        "AreaChart": AreaChart,
        "HorizontalBarChart": HorizontalBarChart,
        "StatsRemote": StatsRemote,
        IperiusONEIcon
    },
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'Dashboard',
        // all titles will be injected into this template
        titleTemplate: '%s | Iperius One ',
    },
    data() {
        return {
            licenseName: "",
            disabledDates: {
                from: new Date(), // Disable all dates after specific date
            },

            //caricati tramite api
            jobs: null,
            events: null,
            sessions: null,
            pcsWithAlerts: null,
            pcsWithAlerts_filters: {
                pcName:'',
                disk_alert: -1,
                av_alert: -1,
                os_patches_alert: -1,
                backup_license_status: -1
            },

            //caricati dalla sessione
            users: null,
            roles: null,
            eventTypes: null,

            loading: false,
            firstline: true,
            lastline: false,
            sessionrow: 0,
            first_dt_start: 0,
            total_session_inarow: "",
            headergroupname: "",
            filters: {
                backupName: '',
                offset: 0,
                lastresult: '',
                status: '',
                dt_inf: '',
                dt_sup: '',
                id_group: '',
                id_pc: '',
                id_host: '',
                id_user: '',
                limit: 25,
                activitystatus: '',
                activityread: false,
                lastResult: "",
            },
            transformedArray: {},

            filterDate: null,
            controls: null,
            checkTFA: {
                step1: null,
                step2: null
            },
            treeViewHtml: null,
            gridView: false,
            subDirectories: [],
            parentDir: null,
            datacollection: null,
            fullStats: null,
            selectedcomputer: null,
            user: null,
            selectedgroup: null,
            selectedbackup: null,
            connected: false,
            licenses: null,
            publicIP: 'Caricamento...',
            privateIP: 'Caricamento...',

            dynamicLabel: this.$t("Show more statistics"),
            newVer: '0.0.0.0',

            checkRemoteConnectionTimer: null,

            onlyremote: false,
        }
    },
    beforeDestroy: function() {
        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
        //this.$root.$off("addBackupsToPage");
        this.$root.$off("is_online");
        this.pcsWithAlerts=null; // Pulire i dati in memoria
        clearInterval(this.checkRemoteConnectionTimer);
        this.sessions=null;
        this.events=null;
        //this.$root.newPage("dashboard", "destroy");
    },
    filters: {
        prettyBytes: function(bytes, precision) {
            return prettyBytes(bytes, precision);
        },

    },
    mounted: async function() {
        await this.$root.getApiDataAndSetSession();

        this.getPCsWithAlerts(false);
        this.licenses=this.$session.getLicenses();

        this.$session.setRoomPC(null);
        this.$root.socket("SETPC", null);

        //this.$root.newPage("dashboard", "mounted");
        this.licenseName=this.$root.authObj.nome_licenza;

        //popolo i valori dei filtri
        this.headergroupname="";
        this.sessionrow=0;
        this.filters.typeList=this.$root.getAllBackupSourceTypes(); //this.$ONEServiceTypeInfo;
        this.filters.resultList=this.$ResultValue;
        this.filters.dt_inf=this.$moment().subtract(5, 'days').format('YYYY-MM-DD')
        this.filters.dt_sup=this.$moment().format('YYYY-MM-DD')

        this.$session.setRoomPC(null);

        this.onlyremote=this.checkisOnlyRemoteLicensingState();



        this.startRetrieveDataFromAPI();

        // this.getPrivateIP()
        //     .then((ip) => console.log("IP privato:", ip))
        //     .catch((error) => console.writeError("Errore:", error));

        this.getLatestIR4Version();

        //this.checkRemoteConnectionTimerLight(); // chiamata ogni 3 secondi per la lista dei remote collegati

    },

    computed: {
        userEmail() {
            return this.$root.authObj.email;
        },
    },
    methods: {

        // [GT - 31/07/2025 ] LEGGENDO IL JSON DI LICENSES, NELLA SESSIONE, CONTROLLA CHE ABBIA SOLO LA LICENZA DI REMOTE
        checkisOnlyRemoteLicensingState() {

            //this.licenses = this.$session.getLicenses();

            if (!this.licenses) {
                console.warn("Licenze non trovate");
                return false;
            }

            const { backup, monitoring, remote }=this.licenses;
            return remote.length>0&&backup.length===0&&monitoring.length===0;
        },

        toggleStatistics() {
            setTimeout(() => {
                var el=Metro.getPlugin('#collapsed-div', 'dropdown');
                this.dynamicLabel=el.isOpen? this.$t("Hide statistics"):this.$t("Show more statistics");

            }, 300);

        },


        async getPrivateIP() {
            return new Promise((resolve, reject) => {
                // Crea una nuova connessione RTC
                const peerConnection=new RTCPeerConnection();

                // Crea un canale dati per inizializzare ICE
                peerConnection.createDataChannel("");

                // Ascolta i candidati ICE generati
                peerConnection.onicecandidate=(event) => {
                    if (event&&event.candidate) {
                        const candidateString=event.candidate.candidate;

                        // Usa una regex per trovare un indirizzo IP
                        const ipRegex=/(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})/; // IPv4 regex
                        const match=candidateString.match(ipRegex);

                        if (match) {
                            resolve(match[1]); // Restituisce l'IP privato
                            peerConnection.close(); // Chiude la connessione dopo aver trovato l'IP
                        }
                    }
                };

                // Genera una descrizione locale per avviare il processo ICE
                peerConnection.createOffer().then((offer) => {
                    peerConnection.setLocalDescription(offer);
                }).catch(reject);
            });
        },


        async getLatestIR4Version() {
            // /api/getversion

            let self=this;


            // [20-11-2024] l'update di un client iperius remote avviene con chiamata alle api come per l'area admin di remote
            // Elixir invierà poi il command di update al client tramite socket
            await this.$api.latestIperiusRemote4Version().then(async response => {
                if (response==null||response.status!=200) {
                    return;
                }

                var major=response.data.major;
                var minor=response.data.minor;
                var release=response.data.release;
                var build=response.data.build;

                this.newVer=major+'.'+minor+'.'+release+'.'+build;

                self.$session.setLastRemoteVersion(this.newVer);

            });


        },

        saveNote(session) {

            let self=this;
            const note={
                id_session: session.id,
                note: session['notes'].length==0? session.notedesc:session['notes'][0].note,
                id: session['notes'].length==0? null:session['notes'][0].id,
                hide_customer: 0
            }

            self.$api.saveNote(note).then((value) => {
                if (value) {
                    self.$root.toast(this.$t(PC_MESSAGES.NOTE_SAVED), "success")
                }
            });
            /*   if ($note["id"] == "") {
                  $response = $http -> post($this -> endpoint.'/api/notes', [
                      'id_session'=> $note["session_id"],
                      'note'=> $note["note"],
                      'hide_customer'=> 0
                  ]);
              } else {
                  $response = $http -> put($this -> endpoint.'/api/notes', [
                      'note'=> $note["note"],
                      'id'=> $note["id"]
                  ]);
              } */
        },




        /********************************STATS*****************************************************/

        //Si effettuano le chiamate API per richiedere i dati più utilizzati e si inseriscono in sessione. 
        //In questo modo verranno presi in maniera più veloce
        //Per praticità, tutte le chiavi di session sono in uppercase
        async startRetrieveDataFromAPI() {

            let self=this;

            this.$root.$on("DeletedJob", idBackup => {
                var index=self.jobs.findIndex(j => j.id==idBackup);
                self.jobs.splice(index, 1);
            });


            this.$api.getEventsTypes().then(res => {
                self.eventTypes=res;
            });

            self.getJobs();

            //EVENTI
            this.$api.getEvents().then(events => {
                self.events=events;
            });

            //VARIE

            self.$api.getSessionsLight().then(res => {
                self.sessions=res;
            });

            this.$api.getStatsFromLicenseLight(null).then(stats => {
                self.fullStats=stats;
            });


        },


        /*****************************BACKUPS*************************************************/



        async getJobs() {
            if (this.jobs!=null&&this.jobs.length>parseInt(this.filters.limit)) {
                return;
            }
            this.$api.getBackups(this.filters).then(jobs => {
                this.jobs=jobs.jobs;

            });
        },




        //metodo per controllare se devo aggiungere o meno la riga iniziale...
        shouldBeAddedBefore(session) {
            if (this.headergroupname==""||session.name_computer_control!=this.headergroupname) {
                this.headergroupname=session.name_computer_control;
                this.sessionrow=1;
                this.total_session_inarow=session.total_time;
                return true;
            }
            if (session.name_computer_control==this.headergroupname) {
                this.total_session_inarow+=session.total_time;
                this.sessionrow+=1;
                return false;
            }

        },
        shouldBeAddedAfter(session) {

            if (this.headergroupname!=""&&session.name_computer_control!=this.headergroupname) {

                return true;
            }
            return false;

        },


        closeCharm() {
            window.Metro.charms.close('#computerselected');
        },

        async openBackupView(idBackup, idPC) {

            //Si vuole aprire la view del job con l'id passato.
            //Il job mostrato sarà un insieme di informazioni prese sia dalla chiamata API, sia dal job arrivato in realtime tramite socket.
            //Per questo secondo tipo di job è necessario che il computer collegato al job sia connesso.
            //Se il computer è connesso, si chiede all'agent l'invio dei backups
            // let self=this;
            // if (this.$root.connectionsStates[idPC]) {
            //     //le chiamate stop e unsubscribe verranno effettuate all'interno di backupview
            //     self.$root.socket("subscribe_pc", idPC)
            //         .then(() => self.$root.socket("STARTSENDINFO"));
            // }
            //this.selectedbackup = this.jobs[index];
            this.$root.$emit("OPENBACKUPVIEW", idBackup);
            //window.Metro.charms.toggle("#backupselected");
        },



        /*****************************UTILS*************************************************/

        closeDialog() {
            this.user=null;
        },

        setEventasRead(event) {
            var arrayID=event.id.split(",");
            this.$api.setAllReadEvents(arrayID).then(result => {
                this.$root.toast(this.$t(EVENTS_MESSAGES.EVENTS_READED), "info");
                event.is_read=true;
            });

        },

        buildHintText(computer) {
            var text="";
            if (computer.disk_alert==1)
                text+="Some disk alert\n";

            if (computer.av_alert==1)
                text+="Some antivirus alert\n";
            return text;
        },

        fromNow(date) {
            if (date==null||date=="") return ""
            return fromNow(date, this.$moment);
        },
        diffDate(datestart, dateend) {
            return diffDate(datestart, dateend, this.$moment);
        },

        showEvent(event) {
            return this.filters.activitystatus==''||event.type==this.filters.activitystatus;
        },

        async getPCsWithAlerts(applyFilters) {

            while(!this.$session.hasPCList()){
                await waitSeconds(1);
            }
            
            this.pcsWithAlerts=null;
            var list=[], f0, f1, f2, f3, f4;
            this.$session.getPCList().forEach(pc => {
                if (pc.oneIsInstalled&&pc.disk_alert+pc.av_alert+pc.os_patches_alert==0)
                    return;

                if (applyFilters) {
                    f0 =this.pcsWithAlerts_filters.pcName ==""
                    f1=[-1, pc.backup_license_status].includes(this.pcsWithAlerts_filters.backup_license_status);
                    f2=this.pcsWithAlerts_filters.disk_alert==-1||(pc.backup_license_status==1&&this.pcsWithAlerts_filters.disk_alert==pc.disk_alert);
                    f3=this.pcsWithAlerts_filters.av_alert==-1||(pc.backup_license_status==1&&this.pcsWithAlerts_filters.av_alert==pc.av_alert);
                    f4=this.pcsWithAlerts_filters.os_patches_alert==-1||(pc.backup_license_status==1&&this.pcsWithAlerts_filters.os_patches_alert==pc.os_patches_alert);

                    if (!(f0 && f1&&f2&&f3&&f4))
                        return;
                }

                list.push(pc);
            });

            this.pcsWithAlerts = list;

        }


    }
};